import React, { useState } from "react";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import MUITabs from "@mui/material/Tabs";

import TabPanel from "./TabPanel";

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

const Tabs = ({
	ariaLabel,
	tabs,
	variant = "standard",
	sticky = false,
	TabPanelProps = {},
	TabPanelBoxProps = {},
	TabActionButton,
}) => {
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box
			sx={{
				width: "100%",
				position: "relative",
			}}
		>
			<Box
				sx={{
					borderBottom: "1px solid",
					borderColor: (theme) => theme.palette.primary.main,
					display: "flex",
					...(sticky && {
						position: "sticky",
						top: 0,
						background: "#fff",
						zIndex: 100,
					}),
				}}
			>
				<MUITabs
					value={value}
					onChange={handleChange}
					aria-label={ariaLabel}
					variant={variant}
					sx={{
						width: variant === "fullWidth" ? "100%" : "auto",
					}}
				>
					{tabs.map((tab, index) => {
						return (
							<Tab
								key={`tab-key-${index}`}
								label={tab.label}
								{...a11yProps(index)}
							/>
						);
					})}
				</MUITabs>
				{TabActionButton && TabActionButton}
			</Box>
			{tabs.map((tab, index) => {
				return (
					<TabPanel
						key={`tabpanel-key-${index}`}
						value={value}
						index={index}
						TabPanelBoxProps={TabPanelBoxProps}
						{...TabPanelProps}
					>
						{/* {tab.content} */}
						<Box sx={{ py: 3 }}>
							{React.cloneElement(tab.content, { setActiveTab: setValue })}
						</Box>
					</TabPanel>
				);
			})}
		</Box>
	);
};

export default Tabs;
